import { render } from "./VendorsReadView.vue?vue&type=template&id=1766b872"
import script from "./VendorsReadView.vue?vue&type=script&lang=js"
export * from "./VendorsReadView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__